'use strict';
import isString from 'lodash/isString';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import {epicErrorHandler} from '../../rx-utils';
import {AbstractEpics} from '../AbstractEpics';

/**
 *
 */
export class UpdateModalEpics extends AbstractEpics {

  /**
   * @param {UpdateModalActions} actions
   * @param {UpdateModalOptions} options
   */
  constructor(actions, options) {
    super(options);

    /** @type {UpdateModalOptions} **/
    this.options = options;
    /** @type {UpdateModalActions} **/
    this.actions = actions;

    this.onSendRequest = this.onSendRequest.bind(this);
    this.onSendRequest.$inject = [
      'fetchUtils',
    ]

    this.addEpic(this.onSendRequest);
    this.onRequestComplete = this.onRequestComplete.bind(this);
    this.addEpic(this.onRequestComplete);
    this.hideOnResult = this.hideOnResult.bind(this);
  }

  onSendRequest(action$, store, dependencies) {
    return action$.ofType(this.actions.sendRequest.TYPE)
      .switchMap(action =>
        Promise.resolve(
          dependencies.fetchUtils.rawRequest(this.getUrl(action), {
            method: this.options.requestMethod,
            headers: {
              'Content-Type': 'application/json',
              ...this.options.getHeaders(action, store.getState()),
            },
            contentType: 'json',
            responseType: 'json',
            body: action.payload.body,
            ...this.options.requestOptions,
          }),
        )
        /* TODO(redux): need to reject() appropriate error data from a failed response */
          .then(response => response.ok ? this.actions.requestSuccess() : this.actions.requestError({err: response}))
          .catch(err => this.actions.requestError({err}))
      )
      .catch(epicErrorHandler(this.logger, 'onSendRequest'));
  }

  onRequestComplete(action$) {
    return action$.ofType(this.actions.requestSuccess.TYPE, this.actions.requestError.TYPE)
      .filter(this.hideOnResult)
      .switchMap(() =>
        Observable.timer(this.options.showMessageTime)
          .mapTo(this.actions.hideModal())
      )
      .catch(epicErrorHandler(this.logger, 'onRequestComplete'));
  }

  hideOnResult(action) {
    return action.type === this.actions.requestSuccess.TYPE || (
      this.options.hideOnError && action.type === this.actions.requestError.TYPE
    );
  }

  getUrl(action) {
    if (isString(this.options.requestUrl)) {
      return this.options.requestUrl;
    } else {
      return this.options.requestUrl(action);
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/redux/update-modal/buildEpics.js